<template>
	<el-container id="range">
		<el-row>
			<el-col :span="24"><h2 class="rangeTit">请选择学习课程</h2></el-col>
		</el-row>
		<el-row type="flex" justify="center" class="xueli" v-if="xueli.length>0">
			<el-col :span="4"><div class="courseType">学历课程</div></el-col>
			<el-col :span="20">
				<dl class="xueliList">
					<dd v-for="(item,index) in xueli" :key="index" @click="idswitch(item)">
						<div class="courseInfo">
							<img :src="item.list[0].logo" class="schoolLogo">
							<div class="level">{{level(item)}}</div>
						</div>
						<div class="marjorBox">
							<div class="marjor">{{item.list[0].major_name}}</div>
							<p class="goMesg">去学习&nbsp;<i class="iconfont">&#xe610;</i></p>
						</div>
					</dd>
				</dl>
			</el-col>
		</el-row>
		<el-row type="flex" justify="center" class="zhiye" v-if="zhiye.length>0">
			<el-col :span="4"><div class="courseType">职业培训</div></el-col>
			<el-col :span="20">
				<dl class="zhiyeList">
					<dd v-for="(item,index) in zhiye" :key="index" @click="idswitch(item)">
						<p class="courseTit">{{item.list[0].major_name}}</p>
						<p class="goMesg">去学习&nbsp;&gt;</p>
					</dd>
				</dl>
			</el-col>
		</el-row>
	</el-container>
</template>

<script>
export default {
	name: 'range'
	,data () {
		return {
			xueliArr:[],
			zhiyeArr:[]
        }
	}
	,created:function(){
		let that = this
		// this.$emit("swmuban",false);		//修改app.vue 的 muban_bol 值
		this.$selfjs.getIdentityCallFn(this,function(resData){
			for(let c=0;c<resData.length;c++){
				let idObj = resData[c]
				if(idObj.id == 5){
					that.zhiyeArr.push(idObj)
				}else{
					that.xueliArr.push(idObj)
				}
			}
		})
	}
	,mounted:function(){
		// console.log(this)

		//动态设置内容高度
		this.$emit("chMinHeight", document.documentElement.clientHeight - 58)

		this.$store.commit("change_vuex",{
			key:"layout",
			value:1
		})
	}
	,methods:{
		//退出登录
		loginOut(){
			var that=this
	
			this.$confirm('确认退出登录？')
			.then(_ => {
				that.$selfjs.loginOUtFn(that, "location")
				let logout_url=this.global.serverSrc + this.global.qianzui + "/login/logout"
				this.$ajax.get(logout_url)
				.then(function(res){
					let resData=res.data;
					if(resData.code==0){
						that.$selfjs.loginOUtFn(that, "location")
					}else{
						console.log(resData.message);
					}
				})
			})
			.catch(_ => {
				this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
			});
		},
		idswitch(item){
			let that = this
			let loading = this.$loading({
          		lock: true,
          		text: '课程切换中',
          		spinner: 'el-icon-loading',
          		background: 'rgba(0, 0, 0, 0.7)'
        	});
			this.$ajax.post(this.global.serverSrc + this.global.qianzui + "/member/check_identity"
				,this.$qs.stringify({
					grade_id:item.list[0].grade_id
				})
			)
			.then(function(res){
				let resData=res.data;
				if(resData.code==0){
					loading.close();
					that.$store.commit("change_vuex",{
						key:"layout",
						value:0
					})
					that.$selfjs.idswitch(that,item)
					that.global.uDetailData = ""				//初始化用户数据
					that.$store.commit("activeIndex","index")	//初始化导航值
					that.$selfjs.swhead(that,'index')		//返回首页
				}else{
					console.log(resData.message);
				}
			})
		}
		//层次文字输出
		,level(item){
			let res=''
			if(item.level == item.list[0].major_level){
				res = item.level
			}else{
				res = item.level+item.list[0].major_level
			}
			return res
		}
	},
	computed:{
		xueli(){
			return this.xueliArr ? this.xueliArr : []
		},
		zhiye(){
			return this.zhiyeArr ? this.zhiyeArr : []
		}
	},
	watch:{
		// xueli:{
		// 	handler (newValue, oldValue) {
		// 		console.log(newValue)
		// 		console.log('obj changed')
		// 	},
		// 	deep: true
		// }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- scoped单页面有效属性 -->

<style>
/* body #app{min-height:100%;} */
</style>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/range.vue